import * as React from "react";
import { RadioGroup } from "@headlessui/react";
import ToggleButton from "./ToggleButton";
import classNames from "classnames";
var classNamesByColumn = {
    1: "grid-cols-1",
    2: "grid-cols-2",
    3: "grid-cols-3",
    4: "grid-cols-4",
    5: "grid-cols-5",
};
export default function ToggleButtonGroup(props) {
    var _a;
    var id = props.id, label = props.label, value = props.value, onChange = props.onChange, options = props.options, variant = props.variant;
    var isCondensed = variant === "condensed";
    var isGrid = variant === "grid";
    var columnClassNames = isGrid ? classNamesByColumn[props.columns] : "";
    return (React.createElement("div", null,
        React.createElement(RadioGroup, { name: id, value: value, onChange: onChange },
            label ? (React.createElement(RadioGroup.Label, { className: "ml-3 px-1 text-xs font-semibold leading-3 text-gray-100" }, label)) : null,
            React.createElement("div", { className: classNames((_a = {
                        "flex w-full rounded ring-1 ring-gray-200": isCondensed
                    },
                    _a["grid w-full gap-2 ".concat(columnClassNames)] = isGrid,
                    _a["mt-1"] = label,
                    _a)) }, options.map(function (option) { return (React.createElement(RadioGroup.Option, { key: option.label, value: option.value, className: "group w-full" }, function (_a) {
                var checked = _a.checked;
                return (React.createElement(ToggleButton, { checked: checked, variant: variant }, option.label));
            })); })))));
}
